"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoIsApplicable = void 0;
var currency_js_1 = __importDefault(require("currency.js"));
var get_1 = __importDefault(require("lodash/get"));
var constants_1 = require("./constants");
var calcSubtotalAmount = function (bundles) {
    return bundles.reduce(function (acc, bundle) { return acc.add(bundle.finalPrice); }, (0, currency_js_1.default)(0)).value;
};
function promoIsApplicable(promotion, products) {
    var reasons = [];
    var basketAmount = calcSubtotalAmount(products);
    var limitUsageMinutes = (0, get_1.default)(promotion, 'limitUsageMinutes', null);
    var limitUsageMilliseconds = limitUsageMinutes * 60 * 1000;
    var hasTimeLimit = Number.isFinite(limitUsageMilliseconds) && limitUsageMilliseconds > 0;
    var lastTimeUsed = Date.now() - (0, get_1.default)(promotion, 'usageTime.updatedAt', null);
    var isTimeLimited = hasTimeLimit && lastTimeUsed < limitUsageMilliseconds;
    var requiresProducts = [constants_1.PromoRequiresProducts.ALL, constants_1.PromoRequiresProducts.SOME].includes(promotion.requiresProducts);
    if (+promotion.minBasket && basketAmount < +promotion.minBasket) {
        reasons.push({
            code: constants_1.promoErrors.MIN_BASKET,
            minRequired: +promotion.minBasket,
            basketAmount: basketAmount,
        });
    }
    if (requiresProducts) {
        // Array.from() because rollup.js can't spread new Set
        var productsUUIDs = Array.from(new Set(products
            .map(function (product) { var _a; return [product.uuid, (_a = product === null || product === void 0 ? void 0 : product.deal) === null || _a === void 0 ? void 0 : _a.uuid]; })
            .flat()
            .filter(Boolean)));
        var commonRequiredProducts = promotion.commonRequiredProducts, requiredProductsCount = promotion.requiredProductsCount;
        var noRequiredProducts = commonRequiredProducts.length < (promotion.requiresProducts === constants_1.PromoRequiresProducts.ALL ? requiredProductsCount : 1);
        if (noRequiredProducts) {
            reasons.push({ code: constants_1.promoErrors.MISSING_REQUIRED_PRODUCTS });
        }
    }
    if (isTimeLimited) {
        reasons.push({
            code: constants_1.promoErrors.LAST_TIME_USAGE,
            lastTimeUsed: Math.floor(lastTimeUsed / 60000),
            limitUsageMinutes: limitUsageMinutes,
        });
    }
    return reasons;
}
exports.promoIsApplicable = promoIsApplicable;
